import getConfig from 'next/config';

export const isNotProduction = (): boolean => {
  const { publicRuntimeConfig } = getConfig();
  const memriseEnv = publicRuntimeConfig.MEMRISE_ENV;
  return memriseEnv === 'testing' || memriseEnv === 'development';
};
